import React from 'react';
import styled from 'styled-components';
import SecondaryButton from './SecondaryButton';
import phone from '../assets/phone.svg';
import mascot from '../assets/mascot_3.svg';
import { motion } from 'framer-motion';
import GrabButton from './GrabButton';
import { Link } from 'react-router-dom';

function HeaderContent() {
  const line1 = '                            Start saving your memories with IMAFEEL';

  const sentence = {
    hidden: { opacity: 1 },
    visible: {
      transition: {
        duration: 2,
        ease: 'easeOut',
        delay: 1.5,
        staggerChildren: 0.04,
      },
    },
  };

  const letter = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
    },
  };

  return (
    <HeaderContentStyled>
      <div className="left-content">
        <div className="left-text-container">
          <motion.h1 variants={sentence} initial="hidden" animate="visible">
            {line1.split('').map((char, index) => {
              return (
                <motion.span key={char + '-' + index} variants={letter}>
                  {char}
                </motion.span>
              );
            })}
          </motion.h1>

          <div className="desc-text">
            <motion.div
              initial={{ x: '-10%', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 1, ease: 'easeOut', delay: 2.8 }}
            >
              <p className="white">Store the best feelings that you have and never forget them.</p>
              <p className="white">
                Life is a journey, <span>FEEL IT</span>
              </p>
            </motion.div>
          </div>
          <motion.div
            initial={{ x: '-40%', opacity: 0 }}
            animate={{ x: 0, opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: 'easeOut', delay: 3 }}
          >
            <Link to="/login">
              <SecondaryButton
                name={'Get Started'}
                whileHover={{
                  x: '30px',
                  scale: 1.2,
                  transition: { duration: 0.5 },
                }}
                whileTap={{ scale: 0.9 }}
              />
            </Link>
          </motion.div>
        </div>
      </div>
      <div className="right-content">
        <motion.div
          className="phone-content"
          initial={{ y: '20%', opacity: 0 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: 'easeOut', delay: 3 }}
        >
          <img src={phone} alt="" className="phone" />
        </motion.div>

        <motion.div
          className="mascot-grag"
          initial={{ x: '-20%', opacity: 0 }}
          animate={{ x: 0, opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: 'easeOut', delay: 3 }}
          drag
          dragConstraints={{
            top: -150,
            left: -150,
            right: 100,
            bottom: 150,
          }}
        >
          <img src={mascot} alt="" className="mascot" />

          <GrabButton />
        </motion.div>
      </div>
    </HeaderContentStyled>
  );
}

const HeaderContentStyled = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-top: 9rem;
  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(1, 1fr);
  }
  .left-content {
    display: flex;
    align-items: center;
    padding-right: 3rem;
    h1 {
      color: #fff;
      font-size: 4rem;
      font-weight: 500;
      @media screen and (max-width: 700px) {
        font-size: 3rem;
      }
    }
    span {
      color: #fff;
    }
    .desc-text {
      padding: 1.4rem 0;

      .white {
        padding: 0.1rem 0;
        line-height: 1.8rem;
        color: #fff;
        span {
          padding: 0.5rem;
          font-size: 2rem;
          font-weight: bold;
        }
      }
    }
  }
  .right-content {
    position: relative;
    display: flex;
    justify-content: center;
    .phone-content {
      display: flex;
      justify-content: center;
      align-content: center;
      .phone {
        width: 80%;
        animation: move3 10s infinite;
        transition: all 0.4s ease-in-out;
        @media screen and (max-width: 800px) {
          width: 80%;
        }
      }
    }

    .mascot-grag {
      position: absolute;
      bottom: 15%;
      left: 0;
      width: 200px;
      height: 200px;
      display: grid;
      align-items: center;
      justify-content: center;
      justify-items: center;
      .mascot {
        transition: all 0.4s ease-in-out;
        animation: move 8s infinite;
        animation-delay: 0.5s;
        transition: all 0.4s ease-in-out;
        height: 100px;
        width: 100px;
      }
    }
  }
  .photo {
    @keyframes move {
      0% {
        transform: translateY(0) rotate(0) scale(1) translateX(0);
      }
      50% {
        transform: translateY(-10px) rotate(20deg) scale(1.1) translateX(10px);
      }
      100% {
        transform: translateY(0) rotate(0deg) scale(1) translateX(0);
      }
    }
    @keyframes move2 {
      0% {
        transform: translateY(0) rotate(0) scale(1) translateX(0);
      }
      50% {
        transform: translateY(-10px) rotate(30deg) scale(1.1) translateX(10px);
      }
      100% {
        transform: translateY(0) rotate(0deg) scale(1) translateX(0);
      }
    }
    @keyframes move3 {
      0% {
        transform: translateY(0) rotate(0) scale(1) translateX(0);
      }
      25% {
        transform: translateY(0) rotate(3deg) scale(1.1) translateX(10px);
      }
      50% {
        transform: translateY(0) rotate(0deg) scale(1.1) translateX(10px);
      }
      75% {
        transform: translateY(0) rotate(-3deg) scale(1.1) translateX(10px);
      }

      100% {
        transform: translateY(0) rotate(0deg) scale(1) translateX(0);
      }
    }
  }
`;

export default HeaderContent;
